import { render, staticRenderFns } from "./linkinvoice.vue?vue&type=template&id=2fb873d2"
import script from "./linkinvoice.vue?vue&type=script&lang=js"
export * from "./linkinvoice.vue?vue&type=script&lang=js"
import style0 from "./linkinvoice.vue?vue&type=style&index=0&id=2fb873d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports